/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2023, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import _ from 'lodash';

import { selectDraftEnvironmentId } from '@ibm-watson/shared/modules/ia/store/environments/selectors';
import { RootState } from '@ibm-watson/shared/ts/state';
import { ParsedOpenAPIExtension } from '../../../../ts/extensions';
import { getFilteredResponses } from '../../components/catalog-openapi/helpers';
import {
  selectAllDraftIntegrations,
  selectExtensionIntegrations
} from './selectors';

/**
 *
 */
export const selectDraftExtensions = (
  state: RootState
): ParsedOpenAPIExtension[] => {
  const parsedExtensions = selectExtensionIntegrations(state);
  const integrations = selectAllDraftIntegrations(state);
  const draftEnvironmentId = selectDraftEnvironmentId(state);
  const parsedExtensionIntegrations = parsedExtensions.filter(
    parsedExtension =>
      integrations.find(
        integration =>
          integration.integration_id === parsedExtension.integration_id
      ) && parsedExtension.environment_id === draftEnvironmentId
  );

  return parsedExtensionIntegrations.map(integration => ({
    ...integration,
    settings: {
      ...integration.settings,
      endpoints: _.isNil(integration.settings?.endpoints)
        ? []
        : integration.settings.endpoints.map(endpoint => ({
            ...endpoint,
            response_properties: getFilteredResponses(
              endpoint.response_properties
            )
          }))
    }
  }));
};
